const getKeyFromSessionStorage = (key) => {
    try {
        return sessionStorage.getItem(key)
    } catch (err) {
        return null
    }
}


export default getKeyFromSessionStorage